import { TextButton } from '@wix/design-system';
import { DomainSearchSuiteModule, ModalsModule } from '@wix/domains-search-suite';
import { parseDomain } from '@wix/domains-serverless-interface';
import React from 'react';
import { MobileStatusBox } from './MobileStatusBox';
export const MobileNotSupportedTld = _ref => {
  let {
    domainName,
    datahook
  } = _ref;
  const {
    Trans
  } = DomainSearchSuiteModule.internals.useTranslations();
  const {
    availableExtensionsModal
  } = ModalsModule.internals.domainsSharedModalsController;
  const {
    tld,
    formattedInput
  } = parseDomain(domainName ?? '');
  return /*#__PURE__*/React.createElement(MobileStatusBox, {
    datahook: datahook,
    transparent: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "domain_search_suite.error.unavailable_domain",
    values: {
      domainName: formattedInput,
      tld: `.${tld}`
    },
    components: [/*#__PURE__*/React.createElement(TextButton, {
      size: "small",
      weight: "thin",
      underline: "always",
      onClick: () => availableExtensionsModal.show({
        variant: 'list'
      })
    })]
  }));
};
//# sourceMappingURL=MobileNotSupportedTld.js.map